import { render, staticRenderFns } from "./CreateFormmx.vue?vue&type=template&id=97f37628&"
import script from "./CreateFormmx.vue?vue&type=script&lang=js&"
export * from "./CreateFormmx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports